<p class="laft-form--title">Datos del beneficiario y origen de los fondos</p>
<form class="laft-form" [formGroup]="beneficiaryDataForm">
  <app-section-message
    title="¿Qué es el Beneficiario Final?"
    text="Un beneficiario final es la persona natural que realmente es dueña o controla una empresa o fondos, incluso si aparece a través de otras personas o empresas."
    type="warning"
  ></app-section-message>
  <section class="laft-form--group">
    <p class="laft-form--group-title u-mb-4">¿Tú eres el beneficiario final?</p>
    <mat-radio-group class="laft-form--group-radio-button" formControlName="isBeneficiary">
      <mat-radio-button [value]="false"><span class="laft-form-option">No</span></mat-radio-button>
      <mat-radio-button [value]="true"><span class="laft-form-option">Sí</span></mat-radio-button>
    </mat-radio-group>
    <div class="representative-form--container" *ngIf="!beneficiaryDataForm.get('isBeneficiary').value">
      <div class="representative-form--person-container">
        <p class="representative-form--title">¿A quién representa?</p>
        <mat-radio-group formControlName="beneficiaryRepresentativeType">
          <mat-radio-button value="persona_natural">Persona natural</mat-radio-button>
          <mat-radio-button value="persona_juridica">Persona jurídica o ente jurídico</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="representative-form--natural-container" *ngIf="isPersonalNatural">
        <div class="form-group">
          <app-input
            formControlName="beneficiaryPersonName"
            label="Nombres y apellidos del representado"
            maxlength="100"
          ></app-input>
          <div class="form-group-2-grid gap-24">
            <app-select
              formControlName="beneficiaryPersonDocumentType"
              defaultOption="national id"
              [options]="idTypeOptions"
              valueField="value"
              textField="text"
              label="Tipo de documento del representado"
            ></app-select>
            <app-input
              formControlName="beneficiaryPersonDocumentNumber"
              label="Número de documento del representado"
            ></app-input>
          </div>
        </div>
        <div class="representative-form--person-radio-button">
          <p class="representative-form--title">Poder por:</p>
          <mat-radio-group formControlName="beneficiaryPersonPowerType">
            <mat-radio-button value="escritura_publica">Escritura pública</mat-radio-button>
            <mat-radio-button value="mandato">Mandato</mat-radio-button>
          </mat-radio-group>
        </div>
        <lib-file-upload
          [iconUpload]="true"
          internalSpacing="s"
          formats="image+pdf"
          [getFileName]="true"
          label="Documento de poder"
          initialLabel="Documento de poder"
          formControlName="beneficiaryPersonDocument"
        ></lib-file-upload>
        <div class="representative-form--person-pep">
          <p class="representative-form--title">¿Es o ha sido una persona políticamente expuesta?</p>
          <mat-radio-group
            formControlName="isBeneficiaryPersonPep"
            class="representative-form--person-pep-radio-button"
          >
            <mat-radio-button [value]="true">Sí</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
          <div class="form-group-2-grid gap-24" *ngIf="isBeneficiaryPersonPep">
            <app-input formControlName="beneficiaryPersonCharge" label="Cargo" maxlength="100"></app-input>
            <app-input
              formControlName="beneficiaryPersonInstitution"
              label="Nombre de la institución"
              maxlength="100"
            ></app-input>
          </div>
        </div>
      </div>
      <div class="representative-form--business-container" *ngIf="!isPersonalNatural">
        <div class="form-group-2-grid gap-16">
          <app-input formControlName="beneficiaryBusinessName" label="Denominación o razón social"></app-input>
          <app-input formControlName="beneficiaryRuc" label="Número de RUC"></app-input>
        </div>
        <div class="representative-form--business-radio-button">
          <p class="representative-form--title">Poder por:</p>
          <mat-radio-group formControlName="beneficiaryPowerType">
            <mat-radio-button value="acta">Acta</mat-radio-button>
            <mat-radio-button value="escritura_publica">Escritura pública</mat-radio-button>
            <mat-radio-button value="mandato">Mandato</mat-radio-button>
          </mat-radio-group>
        </div>
        <lib-file-upload
          [iconUpload]="true"
          internalSpacing="s"
          formats="image+pdf"
          [getFileName]="true"
          label="Documento de poder"
          initialLabel="Documento de poder"
          formControlName="beneficiaryDocument"
        ></lib-file-upload>
      </div>
    </div>
  </section>

  <section class="laft-form--group">
    <p class="laft-form--group-title u-mb-4">Sobre los fondos</p>
    <div class="form-group-2 u-mb-1">
      <app-select
        class="laft-form--block-width"
        formControlName="fundsOrigin"
        [options]="fundsOriginOptions"
        valueField="value"
        textField="text"
        label="Origen de los fondos"
      ></app-select>
      <app-input
        class="laft-form--block-width"
        *ngIf="beneficiaryDataForm.get('fundsOrigin').value === 'other'"
        formControlName="fundsOriginOtherOption"
        label="Origen de los fondos"
      ></app-input>
    </div>

    <div class="form-group-2">
      <app-select
        class="laft-form--block-width"
        formControlName="fundsOriginLocation"
        [options]="fundsOriginLocationOptions"
        valueField="value"
        textField="text"
        label="Lugar de origen de los fondos"
      ></app-select>
      <app-input
        class="laft-form--block-width"
        *ngIf="beneficiaryDataForm.get('fundsOriginLocation').value === 'other'"
        formControlName="fundsOriginLocationOtherOption"
        label="Lugar de origen de los fondos"
      ></app-input>
    </div>
  </section>
  <div class="laft-form--actions">
    <button type="button" class="laft-form--btn-submit" (click)="onContinue()">Continuar</button>
  </div>
</form>
